<template>
    <div id="app">
        <router-view id="router-view-container"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    html,
    body {
        height: calc(100% - 30px);
    }

    @font-face {
        font-family: 'NunitoSans';
        src: url('./assets/fonts/NunitoSans-Regular.ttf');
        font-style: normal;
    }

    #app {
        font-family: NunitoSans, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #000000 !important;
        height: 100%;
        width: 100%;
    }

    #router-view-container {
        /*height: calc(100% - 66px) !important;*/
        height: 100%;
    }
</style>
